import { defineComponent as _defineComponent } from 'vue'
import { ref, watch, CSSProperties } from "vue";

import {
  use_validation,
  ValidatorFuncType,
} from "@/composables/use_validation";
import InputErrors from "@/components/validated_input/InputErrors.vue";
import { generate_uid } from "@/utils";

type PropTypes = {
  value: string;
  aria_required?: boolean;
  validators: ValidatorFuncType<string>[];
  num_rows?: number;
  input_style?: CSSProperties;
  placeholder?: string;
};
type EmitTypes = {
  (e: "input", value: string): void;
  (e: "update:is_valid", value: boolean): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'ValidatedTextAreaInput',
  props: {
    value: null,
    aria_required: { type: Boolean, default: false },
    validators: null,
    num_rows: { default: 3 },
    input_style: null,
    placeholder: null
  },
  emits: ["input", "update:is_valid"],
  setup(__props: any, { emit }: { emit: ({
  (e: "input", value: string): void;
  (e: "update:is_valid", value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { value: string, aria_required: boolean, validators: ValidatorFuncType<string>[], num_rows: number, input_style?: CSSProperties, placeholder?: string };



const label_id = `label-${generate_uid()}`;
const errors_id = `errors-${generate_uid()}`;
const input = ref("");

// Don't show errors until input changes or on_blur
const hide_errors = ref(true);

// Tracks whether any errors are ready to be rendered. Used to determine
// whether error styling should be used, in conjunction with hide_errors.
// This is updated when InputErrors emits.
const has_rendered_errors = ref(false);

watch(
  () => props.value,
  (new_value) => {
    input.value = new_value;
  },
  { immediate: true },
);

watch(input, () => {
  hide_errors.value = false;
});

// TODO: when we upgrade to Vue>=3.3, components using use_validation can just
// import ValidatedInputEmitTypes to define the components emits (can be used to
// define a product type for emits as well).
// i.e. const emit = defineEmits<ValidatedInputEmitTypes<string>>();
// See https://vuejs.org/guide/typescript/composition-api.html#syntax-limitations


const { is_valid, errors } = use_validation<string>({
  input,
  validators: props.validators,
  emit,
});

function on_blur() {
  if (!is_valid.value) {
    hide_errors.value = false;
  }
}

return { __sfc: true,props, label_id, errors_id, input, hide_errors, has_rendered_errors, emit, is_valid, errors, on_blur, InputErrors }
}

})